export const TITLE = "Pe Frontend";

export const UserRole = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  USER: "USER",
} as const;

export const ServiceAction = {
  READ: "READ",
  WRITE: "WRITE",
} as const;

export const Environment = {
  UAT: "UAT",
  PRODUCTION: "PRODUCTION",
} as const;

export const SearchResponseStatus = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  PARTIAL: "PARTIAL",
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
} as const;

export const DocumentStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;

export const ApolloCacheCategory = {
  PERSON_ENRICHMENT: "PERSON_ENRICHMENT",
  ORGANIZATION_ENRICHMENT: "ORGANIZATION_ENRICHMENT",
  PEOPLE_SEARCH: "PEOPLE_SEARCH",
  ORGANIZATION_SEARCH: "ORGANIZATION_SEARCH",
  ACCOUNT_DATA: "ACCOUNT_DATA",
  CONTACT_DATA: "CONTACT_DATA",
  DEAL_DATA: "DEAL_DATA",
  SEQUENCE_DATA: "SEQUENCE_DATA",
  TASK_DATA: "TASK_DATA",
  CALL_DATA: "CALL_DATA",
  MISCELLANEOUS: "MISCELLANEOUS",
} as const;

export const PerplexityCacheCategory = {
  CHAT_COMPLETION: "CHAT_COMPLETION",
  SEARCH: "SEARCH",
  RESEARCH: "RESEARCH",
  ANALYSIS: "ANALYSIS",
  MISCELLANEOUS: "MISCELLANEOUS",
} as const;

export const ServiceOptionType = {
  STRING: "STRING",
  NUMBER: "NUMBER",
  BOOLEAN: "BOOLEAN",
  DATE: "DATE",
  JSON: "JSON",
} as const;
export const ServiceCode = {
  MATRIX: 'MATRIX',
  AUDIT_MANAGEMENT: 'AUDIT_MANAGEMENT',
  AUTH_MANAGEMENT: 'AUTH_MANAGEMENT',
  DEEP_SEARCH: 'DEEP_SEARCH',
  SERVICE_MANAGEMENT: 'SERVICE_MANAGEMENT',
  BRAND_MANAGEMENT: 'BRAND_MANAGEMENT',
} as const;
 
export const TenantType  = {
  REAL_ESTATE: "REAL_ESTATE",
  NON_REAL_ESTATE: "NON_REAL_ESTATE",
} as const;

// Type definitions for better TypeScript support
export type UserRole = typeof UserRole[keyof typeof UserRole];
export type ServiceAction = typeof ServiceAction[keyof typeof ServiceAction];
export type Environment = typeof Environment[keyof typeof Environment];
export type SearchResponseStatus = typeof SearchResponseStatus[keyof typeof SearchResponseStatus];
export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];
export type ApolloCacheCategory = typeof ApolloCacheCategory[keyof typeof ApolloCacheCategory];
export type PerplexityCacheCategory = typeof PerplexityCacheCategory[keyof typeof PerplexityCacheCategory];
export type ServiceOptionType = typeof ServiceOptionType[keyof typeof ServiceOptionType];
export type ServiceCode = typeof ServiceCode[keyof typeof ServiceCode];
export type TenantType = typeof TenantType[keyof typeof TenantType];

